import { atom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';
import { ExtendedToastProps, LoadingId, THEME, User } from '../types';

//general ui state
export const loadingIdsState = atom<LoadingId[]>([]);
export const sidebarMenuPinnedState = atom(false);
/** Top-level nav section id → submenu open; persisted so expand/collapse survives route changes and reloads. */
export const sidebarNavSubmenuOpenState = atomWithStorage<Record<string, boolean>>(
  'svp.sidebarNavSubmenuOpen',
  {}
);
export const isOpenToastMessageState = atom(false);
export const configToastMessageState = atom<ExtendedToastProps | null>(null);
export const selectedThemeState = atom<THEME | null>(null);
export const isSmallScreenState = atom<boolean>(false);

//user state
export const userState = atom<User | null>(null);
export const isUserLoadingState = atom<boolean>(true);
export const isUserDeactivatedState = atom<boolean>(false);
